module.exports = __webpack_public_path__ + "img/2.7fdde8cb.png";